import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";

import { faireLinks, IFooterLink } from "./footerContent";

export const FaireLinks: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();

  return (
    <>
      {faireLinks(strictLocalize).map((section, index) => (
        <FaireLinksGroup key={index}>
          <Typography variant="paragraphSansMedium">{section.title}</Typography>
          <Spacer size={12} />
          {section.links.map((link, index) => (
            <VerticalLink key={link.path} index={index} link={link} />
          ))}
        </FaireLinksGroup>
      ))}
    </>
  );
};

const VerticalLink: React.FC<{ index: number; link: IFooterLink }> = ({
  index,
  link,
}) => {
  return (
    <>
      {index === 0 ? null : <Spacer height={4} />}
      <FaireLink href={link.path} target={link.target}>
        <Typography>{link.text}</Typography>
      </FaireLink>
    </>
  );
};

const FaireLinksGroup = styled.div`
  margin-bottom: 24px;

  ${responsiveMediaQueries.mobile} {
    padding-bottom: ${getSpacing("2x")};
    border-bottom: 1px solid ${Core.border.muted};
    margin-bottom: ${getSpacing("2x")};

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    margin-bottom: 0px;
    & + & {
      margin-left: 40px;
    }
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    & + & {
      margin-left: 56px;
    }
  }
`;

const FaireLink = styled(Anchor)`
  display: block;
  margin-bottom: ${getSpacing(2)};

  &:hover > p {
    color: ${Core.text.hover};
  }
`;
